<app-tab
	[tabs]="beneTabs"
	[navTab]="activeTab"
	(action)="onTabClick($event)"
></app-tab>

<aside [attr.id]="isSanusMode ? 'sanus-menu' : 'default-menu'">
	<ng-container *ngIf="!isSanusMode; else sanusModeContent">
		<button
			id="new-beneficiary"
			mat-flat-button
			color="primary"
			(click)="onNewBeneficiary()"
		>
			<mat-icon>add</mat-icon>
			<span class="no-mob">Novo beneficiário</span>
		</button>
		<div class="d-f jc-fe ai-c mb-xxs">
			<p class="fs-xxs mr-nano">Beneficiários ativos:</p>
			<button mat-button color="primary" (click)="onActiveDataDownload()">
				<mat-icon svgIcon="sanus-download"></mat-icon>
				<span>Baixar Relatório</span>
			</button>
		</div>
	</ng-container>

	<ng-template #sanusModeContent>
		<button
			id="new-beneficiary"
			mat-flat-button
			color="primary"
			(click)="onNewBeneficiary()"
		>
			<mat-icon>add</mat-icon>
			<span class="no-mob">Novo beneficiário</span>
		</button>

		<span class="download-report">
			<mat-icon>list_alt</mat-icon>
			<span id="icon-labeled">
				<p>Beneficiários ativos:</p>
			</span>
			<button mat-button color="primary" (click)="onActiveDataDownload()">
				<mat-icon svgIcon="sanus-download"></mat-icon>
				<span>Baixar Relatório</span>
			</button>
		</span>
		<span class="download-report">
			<mat-icon [ngStyle]="{ color: 'grey' }">list_alt</mat-icon>
			<span id="icon-labeled">
				<p>Beneficiários inativos:</p>
			</span>
			<button mat-button color="primary" (click)="onInactiveDataDownload()">
				<mat-icon svgIcon="sanus-download"></mat-icon>
				<span>Baixar Relatório</span>
			</button>
		</span>
	</ng-template>
</aside>

<section id="search" [formGroup]="searchForm">
	<mat-form-field title="Busca de beneficiários" appearance="outline">
		<mat-label>Busca de beneficiários</mat-label>
		<input
			type="text"
			matInput
			placeholder="Busca de beneficiários"
			formControlName="term"
			id="sms-{{ inputId }}"
			(keyup)="onSearchKeyUp($event)"
		/>
		<button
			*ngIf="!searchButton"
			matSuffix
			mat-icon-button
			color="primary"
			aria-label="Clear search"
			(click)="onClearSearch()"
		>
			<mat-icon>close</mat-icon>
		</button>
		<button
			*ngIf="searchButton"
			matSuffix
			mat-icon-button
			color="primary"
			aria-label="Search beneficiaries"
			[disabled]="isSearchButtonDisabled"
			(click)="getBeneficiaries({ hideSearchBtn: true })"
		>
			<mat-icon>search</mat-icon>
		</button>
	</mat-form-field>
</section>

<section class="table">
	<table
		matSort
		mat-table
		[dataSource]="isLoading ? [] : beneficiaries"
		(matSortChange)="onSortData($event)"
	>
		<ng-container matColumnDef="status">
			<th mat-header-cell *matHeaderCellDef>Status</th>
			<td mat-cell *matCellDef="let element">
				<ng-container *ngIf="!isLoading">
					<span
						class="badge"
						[class]="processStatusCssClass(element.pendency)"
						(click)="onPendencyDialogOpen($event, element.id, element.status)"
						(keyup)="onPendencyDialogOpen($event, element.id, element.status)"
						tabindex="0"
					>
						{{ processedStatus(element.pendency) }}
					</span>
				</ng-container>
			</td>
		</ng-container>

		<ng-container matColumnDef="name">
			<th
				mat-header-cell
				*matHeaderCellDef
				[mat-sort-header]="beneficiariesFieldOrdinationEnum.NAME"
				sortActionDescription="Ordenar por nome"
			>
				Nome
			</th>
			<td
				mat-cell
				*matCellDef="let element"
				class="pointer"
				(click)="onEditBeneficiary(element.id)"
				(keydown)="onEditBeneficiary(element.id)"
			>
				<ng-container *ngIf="!isLoading">
					{{ element.user.name }}
				</ng-container>
			</td>
		</ng-container>

		<ng-container matColumnDef="phone">
			<th mat-header-cell *matHeaderCellDef>Telefone</th>
			<td
				mat-cell
				*matCellDef="let element"
				class="pointer"
				(click)="onEditBeneficiary(element.id)"
				(keydown)="onEditBeneficiary(element.id)"
			>
				<ng-container *ngIf="!isLoading">
					{{
						element?.user?.phone
							? (element.user.phone | mask: phoneMask(element.user.phone))
							: nullPlaceholder
					}}
				</ng-container>
			</td>
		</ng-container>

		<ng-container matColumnDef="cpf">
			<th mat-header-cell *matHeaderCellDef>CPF</th>
			<td
				mat-cell
				*matCellDef="let beneficiary"
				class="pointer text-wrap-nowrap"
				(click)="onEditBeneficiary(beneficiary.id)"
				(keydown)="onEditBeneficiary(beneficiary.id)"
			>
				<ng-container *ngIf="!isLoading">
					{{ beneficiary.user.cpf | mask: cpfMask }}
				</ng-container>
			</td>
		</ng-container>

		<ng-container matColumnDef="createdAt">
			<th
				mat-header-cell
				*matHeaderCellDef
				[mat-sort-header]="beneficiariesFieldOrdinationEnum.CREATION_DATE"
				sortActionDescription="Ordenar por data de cadastro"
			>
				Cadastro
			</th>
			<td
				mat-cell
				*matCellDef="let beneficiary"
				class="pointer"
				(click)="onEditBeneficiary(beneficiary.id)"
				(keydown)="onEditBeneficiary(beneficiary.id)"
			>
				<ng-container *ngIf="!isLoading">
					{{ beneficiary.user.created_at | date: 'dd/MM/YYYY' }}
				</ng-container>
			</td>
		</ng-container>

		<ng-container matColumnDef="type">
			<th mat-header-cell *matHeaderCellDef>Tipo</th>
			<td
				mat-cell
				*matCellDef="let element"
				class="pointer"
				(click)="onEditBeneficiary(element.id)"
				(keydown)="onEditBeneficiary(element.id)"
			>
				<ng-container *ngIf="!isLoading">
					{{ isBeneficiaryHolder(element) ? 'Titular' : 'Dependente' }}
				</ng-container>
			</td>
		</ng-container>

		<ng-container matColumnDef="exclusionDate">
			<th
				mat-header-cell
				*matHeaderCellDef
				[mat-sort-header]="beneficiariesFieldOrdinationEnum.EXCLUSION_DATE"
				sortActionDescription="Ordenar por data de exclusão"
			>
				Exclusão
			</th>
			<td
				mat-cell
				*matCellDef="let beneficiary"
				class="pointer"
				(click)="onEditBeneficiary(beneficiary.id)"
				(keydown)="onEditBeneficiary(beneficiary.id)"
			>
				<ng-container *ngIf="!isLoading">
					{{ beneficiary.exclusionDate | date: 'dd/MM/YYYY' }}
				</ng-container>
			</td>
		</ng-container>

		<ng-container matColumnDef="dependentCount">
			<th
				mat-header-cell
				*matHeaderCellDef
				id="dependents"
				class=".padding-zero-h"
			>
				Dependentes
			</th>
			<td
				mat-cell
				*matCellDef="let beneficiary"
				class="pointer"
				(click)="onEditBeneficiary(beneficiary.id)"
				(keydown)="onEditBeneficiary(beneficiary.id)"
			>
				<ng-container *ngIf="!isLoading">
					{{ beneficiary.countDependents }}
				</ng-container>
			</td>
		</ng-container>

		<ng-container matColumnDef="removedFromInsurance">
			<th
				mat-header-cell
				*matHeaderCellDef
				[mat-sort-header]="beneficiariesFieldOrdinationEnum.INACTIVATION_DATE"
				sortActionDescription="Ordenar por data de inativação"
			>
				Inativação
			</th>
			<td
				mat-cell
				*matCellDef="let beneficiary"
				class="pointer"
				(click)="onEditBeneficiary(beneficiary.id)"
				(keydown)="onEditBeneficiary(beneficiary.id)"
			>
				<ng-container *ngIf="!isLoading">
					{{
						beneficiary.insuranceInactivatedAt
							? (beneficiary.insuranceInactivatedAt | date: 'dd/MM/yyyy')
							: nullPlaceholder
					}}
				</ng-container>
			</td>
		</ng-container>

		<ng-container matColumnDef="scheduledDate">
			<th
				mat-header-cell
				*matHeaderCellDef
				[mat-sort-header]="beneficiariesFieldOrdinationEnum.SCHEDULED_DATE"
			>
				Data Prevista
			</th>
			<td mat-cell *matCellDef="let element">
				<ng-container *ngIf="element.transfers?.length > 0">
					{{ element.transfers[0]?.scheduledDate | date: 'dd/MM/yyyy' }}
				</ng-container>
			</td>
		</ng-container>

		<ng-container matColumnDef="origin">
			<th mat-header-cell *matHeaderCellDef>Origem</th>
			<td mat-cell *matCellDef="let element">
				<ng-container *ngIf="element.transfers?.length > 0">
					{{ element.transfers[0]?.fromOrganization?.name_secondary }}
				</ng-container>
			</td>
		</ng-container>

		<ng-container matColumnDef="destination">
			<th mat-header-cell *matHeaderCellDef>Destino</th>
			<td mat-cell *matCellDef="let element">
				<ng-container *ngIf="element.transfers?.length > 0">
					{{ element.transfers[0]?.toOrganization?.name_secondary }}
				</ng-container>
			</td>
		</ng-container>

		<ng-container matColumnDef="actions">
			<th mat-header-cell *matHeaderCellDef>Ações</th>
			<td mat-cell *matCellDef="let element">
				<ng-container
					*ngIf="element.canCancelTransfer && element.transfers?.length > 0"
				>
					<button
						mat-icon-button
						color="warn"
						(click)="openCancelModal(element)"
					>
						<mat-icon>cancel</mat-icon>
					</button>
				</ng-container>
			</td>
		</ng-container>

		<tr mat-header-row *matHeaderRowDef="tableColumnsShown"></tr>
		<tr mat-row *matRowDef="let row; columns: tableColumnsShown"></tr>
	</table>

	<ng-container *ngIf="isLoading; else dataOrEmpty">
		<mat-spinner diameter="48"></mat-spinner>
	</ng-container>

	<ng-template #dataOrEmpty>
		<div class="table-empty" *ngIf="!hasBeneficiaries()">
			<p *ngIf="!getWithSearchTerm">
				<span *ngIf="selectedLabel !== 'transferências programadas'">
					{{ selectedLabel }}
				</span>
			</p>
			<p *ngIf="getWithSearchTerm">
				Nenhum resultado encontrado, verifique os termos digitados e busque
				novamente
			</p>
		</div>
	</ng-template>

	<mat-paginator
		showFirstLastButtons
		[pageSizeOptions]="[10, 20, 50, 100]"
		[length]="tableTotalItems"
		(page)="onChangePage($event)"
	></mat-paginator>
</section>

<app-cancel-transfer-modal
	*ngIf="showCancelTransferModal"
	[transfer]="selectedTransfer"
	[beneficiaryName]="selectedBeneficiaryName"
	[hasDependent]="selectedBeneficiaryHasDependents"
	(close)="onCloseCancelTransferModal()"
	(confirm)="onConfirmCancelTransfer()"
></app-cancel-transfer-modal>
